export const PRODUCT_TYPE_SELLING = 0;
export const PRODUCT_TYPE_SOLD = 10;
